import Account from './container'

export default Account
